import { signalingPhoneStreamStarted } from 'features/sip/actions';
import { phoneStreamUpdated } from 'features/sip/sipSlice';
import { call, put } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';

export function* onPhoneStreamStartSaga(action: ReturnType<typeof signalingPhoneStreamStarted>) {
  const { feedId, streams } = action.payload;

  yield call(RTCClient.receivingFeed.addAvailableStreams, feedId, streams);

  yield call(RTCClient.setBroadcastingState, feedId, streams);

  yield call(
    RTCClient.subscribe,
    {
      feedId,
      streams,
      id: feedId,
    },
    'phone'
  );

  yield put(
    phoneStreamUpdated({
      feedId,
      streams,
    })
  );
}
